export enum RelationshipType {
  PARTNER = 'partner',
  SINGLE = 'single',
}

export enum RelationshipStatuses {
  SINGLE = 'single',
  IN_A_RELATIONSHIP = 'in a relationship',
  MARRIED = 'married',
  COMPLICATED = 'complicated',
  UNSURE = 'unsure/other',
}

const RelationshipTypesToStatusesMap: Record<RelationshipType, RelationshipStatuses[]> = {
  [RelationshipType.PARTNER]: [
    RelationshipStatuses.IN_A_RELATIONSHIP,
    RelationshipStatuses.MARRIED,
  ],
  [RelationshipType.SINGLE]: [
    RelationshipStatuses.SINGLE,
    RelationshipStatuses.COMPLICATED,
    RelationshipStatuses.UNSURE,
  ],
};

export const getRelationshipTypeByStatus = (relationshipStatus: RelationshipStatuses) =>
  RelationshipTypesToStatusesMap.single.includes(relationshipStatus)
    ? RelationshipType.SINGLE
    : RelationshipType.PARTNER;
